(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mentor-contact"] && !Shopify.designMode) return;
  try {
    
(()=>{
const init=()=>document.querySelectorAll('.mw-contact').forEach(root=>{
 if(root.dataset.contactReady)return;root.dataset.contactReady='true';
 const params=new URLSearchParams(window.location.search);
 const packageField=root.querySelector('select[name="contact[pacchetto]"]'),serviceField=root.querySelector('select[name="contact[servizio]"]');
 const selectedPackage=params.get('pacchetto'),selectedService=params.get('servizio'),selectedSubscription=params.get('abbonamento');
 if(packageField&&['Starter','Business','Premium','E-commerce'].includes(selectedPackage))packageField.value=selectedPackage;
 if(serviceField&&['Sito web aziendale','E-commerce','SEO e marketing'].includes(selectedService))serviceField.value=selectedService;
 if(serviceField&&selectedPackage==='E-commerce')serviceField.value='E-commerce';
 const subscriptionServices={"Gestione sito web":"Sito web aziendale","Gestione e-commerce":"E-commerce","Gestione pubblicità Meta":"SEO e marketing","Gestione social":"SEO e marketing"};
 if(packageField&&Object.hasOwn(subscriptionServices,selectedSubscription)){packageField.value=selectedSubscription;if(serviceField)serviceField.value=subscriptionServices[selectedSubscription];}
 const feedback=root.querySelector('.mw-form-success,.mw-form-error');
 if(feedback){feedback.tabIndex=-1;feedback.focus();}
});
document.addEventListener('click',event=>{
 const link=event.target.closest('a[data-mentor-package]');if(!link)return;
 const root=document.querySelector('.mw-contact');if(!root)return;
 const select=root.querySelector('select[name="contact[pacchetto]"]');if(select)select.value=link.dataset.mentorPackage;
 const service=root.querySelector('select[name="contact[servizio]"]');if(service&&link.dataset.mentorPackage==='E-commerce')service.value='E-commerce';
});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mentor-demo-ecommerce"] && !Shopify.designMode) return;
  try {
    
(()=>{
const init=()=>document.querySelectorAll('[data-fe-root]').forEach(root=>{
if(root.dataset.ready)return;root.dataset.ready='true';
const money=value=>new Intl.NumberFormat('it-IT',{style:'currency',currency:'EUR'}).format(value/100);
const cards=[...root.querySelectorAll('[data-product]')],grid=root.querySelector('.fe-product-grid');
const productDialog=root.querySelector('.fe-product-dialog'),cartDialog=root.querySelector('.fe-cart-dialog');
const variant=root.querySelector('[data-detail-variant]'),qty=root.querySelector('[data-detail-qty]');
let current=null,category='all',cart=[];
const clamp=(value,max=20)=>Math.max(1,Math.min(max,Math.floor(Number(value)||1)));
function filter(){
 const search=root.querySelector('[data-search]').value.toLocaleLowerCase('it');
 cards.forEach(c=>c.hidden=!(category==='all'||c.dataset.category===category)||!c.dataset.name.toLocaleLowerCase('it').includes(search));
 const mode=root.querySelector('[data-sort]').value;
 [...cards].sort((a,b)=>mode==='low'?Number(a.dataset.price)-Number(b.dataset.price):mode==='high'?Number(b.dataset.price)-Number(a.dataset.price):cards.indexOf(a)-cards.indexOf(b)).forEach(c=>grid.append(c));
 const count=cards.filter(c=>!c.hidden).length;root.querySelector('[data-results]').textContent=root.dataset.countLabel+' '+count;root.querySelector('[data-no-results]').hidden=!!count;
}
root.querySelectorAll('[data-category-filter]').forEach(button=>button.addEventListener('click',()=>{category=button.dataset.categoryFilter;root.querySelectorAll('[data-category-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));filter();}));
root.querySelector('[data-search]').addEventListener('input',filter);root.querySelector('[data-sort]').addEventListener('change',filter);
root.querySelector('[data-reset]').addEventListener('click',()=>{root.querySelector('[data-search]').value='';category='all';root.querySelector('[data-sort]').value='featured';root.querySelectorAll('[data-category-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.categoryFilter==='all')));filter();});
root.querySelectorAll('[data-close-dialog]').forEach(b=>b.addEventListener('click',()=>b.closest('dialog').close()));
[productDialog,cartDialog].forEach(d=>d.addEventListener('click',e=>{const r=d.getBoundingClientRect();if(e.target===d&&(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom))d.close();}));
function price(){return Number(current.dataset.price)+(variant.value==='1'?1000:0);}
root.querySelectorAll('[data-open-product]').forEach(b=>b.addEventListener('click',()=>{
current=cards.find(c=>c.dataset.product===b.dataset.openProduct);const d=current.dataset,img=current.querySelector('img'),detailImg=root.querySelector('[data-detail-image]');
root.querySelector('#fe-product-title').textContent=d.name;root.querySelector('[data-detail-desc]').textContent=d.desc;root.querySelector('[data-detail-material]').textContent=d.material;root.querySelector('[data-detail-care]').textContent=d.care;
detailImg.src=img.src;detailImg.alt=img.alt;variant.replaceChildren(new Option(d.variantOne,'0'),new Option(d.variantTwo+' · '+money(Number(d.price)+1000),'1'));qty.value='1';root.querySelector('[data-detail-price]').textContent=money(price());root.querySelector('[data-detail-status]').textContent='';productDialog.showModal();
}));
variant.addEventListener('change',()=>root.querySelector('[data-detail-price]').textContent=money(price()));
root.querySelector('[data-add-to-demo]').addEventListener('click',()=>{
qty.value=clamp(qty.value);const key=current.dataset.product+'-'+variant.value;let line=cart.find(x=>x.key===key);
if(line)line.qty=Math.min(99,line.qty+Number(qty.value));else cart.push({key,name:current.dataset.name,variant:variant.value==='0'?current.dataset.variantOne:current.dataset.variantTwo,price:price(),qty:Number(qty.value),image:current.querySelector('img').src,alt:current.querySelector('img').alt});
root.querySelector('[data-detail-status]').textContent=root.dataset.addedLabel;root.querySelector('[data-checkout-status]').hidden=true;renderCart();
});
function renderCart(){
const container=root.querySelector('.fe-cart-items');container.replaceChildren();
if(!cart.length){const p=document.createElement('p');p.className='fe-cart-empty';p.textContent=root.dataset.emptyLabel;container.append(p);}
cart.forEach(line=>{
const el=document.createElement('article');el.className='fe-cart-line';const image=document.createElement('img');image.src=line.image;image.alt=line.alt;image.width=80;image.height=100;
const info=document.createElement('div'),name=document.createElement('h3'),format=document.createElement('p'),row=document.createElement('div');name.textContent=line.name;format.textContent=line.variant;row.className='fe-cart-line-bottom';
const input=document.createElement('input');input.type='number';input.min='1';input.max='99';input.value=line.qty;input.setAttribute('aria-label',root.dataset.quantityLabel+' '+line.name);
input.addEventListener('input',()=>{line.qty=clamp(input.value,99);amount.textContent=money(line.price*line.qty);updateTotals();root.querySelector('[data-checkout-status]').hidden=true;});input.addEventListener('change',()=>{input.value=line.qty;});
const remove=document.createElement('button');remove.type='button';remove.textContent=root.dataset.removeLabel;remove.setAttribute('aria-label',root.dataset.removeLabel+' '+line.name);remove.addEventListener('click',()=>{cart=cart.filter(x=>x.key!==line.key);renderCart();root.querySelector('[data-checkout-status]').hidden=true;});
const amount=document.createElement('b');amount.textContent=money(line.price*line.qty);row.append(input,remove,amount);info.append(name,format,row);el.append(image,info);container.append(el);
});
updateTotals();
}
function updateTotals(){
const subtotal=cart.reduce((s,l)=>s+l.price*l.qty,0),shipping=subtotal&&subtotal<15000?690:0;
root.querySelector('[data-cart-count]').textContent=cart.reduce((s,l)=>s+l.qty,0);
root.querySelector('[data-cart-subtotal]').textContent=money(subtotal);root.querySelector('[data-cart-shipping]').textContent=money(shipping);root.querySelector('[data-cart-total]').textContent=money(subtotal+shipping);
root.querySelector('[data-shipping-copy]').textContent=subtotal>=15000?root.dataset.freeLabel:root.dataset.shippingLabel+' '+money(15000-subtotal);
root.querySelector('[data-shipping-progress]').value=Math.min(subtotal,15000);root.querySelector('[data-demo-checkout]').disabled=!cart.length;
}
root.querySelector('[data-open-cart]').addEventListener('click',()=>{renderCart();cartDialog.showModal();});
root.querySelector('[data-demo-checkout]').addEventListener('click',()=>{const status=root.querySelector('[data-checkout-status]');status.textContent=root.dataset.checkoutLabel;status.hidden=false;});
renderCart();
});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mentor-demo-edile"] && !Shopify.designMode) return;
  try {
    
(() => {
const initMentorShowcase = () => {
 document.querySelectorAll('.mx-demo').forEach(root => {
  if (root.dataset.mentorShowcaseReady) return;
  root.dataset.mentorShowcaseReady = 'true';
  root.querySelectorAll('.mx-demo-form').forEach(form => {
   form.addEventListener('submit', event => {
    event.preventDefault();
    if (!form.reportValidity()) return;
    const status = form.querySelector('.mx-form-status');
    status.textContent = form.dataset.demoSuccess;
    status.hidden = false;
   });
   form.querySelector('button[type="submit"]').disabled = false;
  });
  root.querySelectorAll('[data-menu-filter]').forEach(button => {
   button.addEventListener('click', () => {
    const category = button.dataset.menuFilter;
    root.querySelectorAll('[data-menu-filter]').forEach(tab => tab.setAttribute('aria-pressed', String(tab === button)));
    root.querySelectorAll('[data-menu-category]').forEach(item => item.hidden = category !== 'all' && item.dataset.menuCategory !== category);
    const status = root.querySelector('.mx-menu-status');
    if (status) {
     const visible = [...root.querySelectorAll('[data-menu-category]')].filter(item => !item.hidden).length;
     status.textContent = root.dataset.menuStatusLabel + ' ' + visible;
    }
   });
  });
  const date = root.querySelector('input[type="date"]');
  if (date) {
   const today = new Date();
   date.min = [today.getFullYear(), String(today.getMonth()+1).padStart(2,'0'), String(today.getDate()).padStart(2,'0')].join('-');
  }
 });
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMentorShowcase, {once:true});
else initMentorShowcase();
document.addEventListener('shopify:section:load', initMentorShowcase);
})();
(()=>{
const init=()=>document.querySelectorAll('.mx-rich').forEach(root=>{
 if(root.dataset.richReady)return;root.dataset.richReady='true';
 root.querySelectorAll('[data-palette]').forEach(button=>button.addEventListener('click',()=>{
 const value=button.dataset.palette;root.querySelector('[data-palette-board]').dataset.paletteBoard=value;
 root.querySelectorAll('[data-palette]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
 const caption=root.querySelector('.mx-palette-caption');caption.textContent=caption.dataset[value];
 }));
 const range=root.querySelector('[data-brief-size]');if(range)range.addEventListener('input',()=>root.querySelector('[data-brief-size-output]').textContent=range.value+' m²');
 const build=root.querySelector('[data-brief-build]');if(build)build.addEventListener('click',()=>{
 const parts=[root.querySelector('[data-brief-space]').value,range.value+' m²',root.querySelector('input[name="brief-priority"]:checked').value,root.querySelector('[data-palette][aria-pressed="true"]').textContent];
 root.querySelector('[data-brief-result]').textContent=parts.join(' · ');root.querySelector('.mx-brief-result').hidden=false;
 });
 const pairing=root.querySelector('[data-pairing]');if(pairing)pairing.addEventListener('change',()=>{
 const data=root.querySelector('[data-wine-values]').dataset;root.querySelector('[data-wine-title]').textContent=data[pairing.value+'Title'];root.querySelector('[data-wine-copy]').textContent=data[pairing.value+'Copy'];
 });
});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mentor-demo-ristorante"] && !Shopify.designMode) return;
  try {
    
(() => {
const initMentorShowcase = () => {
 document.querySelectorAll('.mx-demo').forEach(root => {
  if (root.dataset.mentorShowcaseReady) return;
  root.dataset.mentorShowcaseReady = 'true';
  root.querySelectorAll('.mx-demo-form').forEach(form => {
   form.addEventListener('submit', event => {
    event.preventDefault();
    if (!form.reportValidity()) return;
    const status = form.querySelector('.mx-form-status');
    status.textContent = form.dataset.demoSuccess;
    status.hidden = false;
   });
   form.querySelector('button[type="submit"]').disabled = false;
  });
  root.querySelectorAll('[data-menu-filter]').forEach(button => {
   button.addEventListener('click', () => {
    const category = button.dataset.menuFilter;
    root.querySelectorAll('[data-menu-filter]').forEach(tab => tab.setAttribute('aria-pressed', String(tab === button)));
    root.querySelectorAll('[data-menu-category]').forEach(item => item.hidden = category !== 'all' && item.dataset.menuCategory !== category);
    const status = root.querySelector('.mx-menu-status');
    if (status) {
     const visible = [...root.querySelectorAll('[data-menu-category]')].filter(item => !item.hidden).length;
     status.textContent = root.dataset.menuStatusLabel + ' ' + visible;
    }
   });
  });
  const date = root.querySelector('input[type="date"]');
  if (date) {
   const today = new Date();
   date.min = [today.getFullYear(), String(today.getMonth()+1).padStart(2,'0'), String(today.getDate()).padStart(2,'0')].join('-');
  }
 });
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMentorShowcase, {once:true});
else initMentorShowcase();
document.addEventListener('shopify:section:load', initMentorShowcase);
})();
(()=>{
const init=()=>document.querySelectorAll('.mx-rich').forEach(root=>{
 if(root.dataset.richReady)return;root.dataset.richReady='true';
 root.querySelectorAll('[data-palette]').forEach(button=>button.addEventListener('click',()=>{
 const value=button.dataset.palette;root.querySelector('[data-palette-board]').dataset.paletteBoard=value;
 root.querySelectorAll('[data-palette]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
 const caption=root.querySelector('.mx-palette-caption');caption.textContent=caption.dataset[value];
 }));
 const range=root.querySelector('[data-brief-size]');if(range)range.addEventListener('input',()=>root.querySelector('[data-brief-size-output]').textContent=range.value+' m²');
 const build=root.querySelector('[data-brief-build]');if(build)build.addEventListener('click',()=>{
 const parts=[root.querySelector('[data-brief-space]').value,range.value+' m²',root.querySelector('input[name="brief-priority"]:checked').value,root.querySelector('[data-palette][aria-pressed="true"]').textContent];
 root.querySelector('[data-brief-result]').textContent=parts.join(' · ');root.querySelector('.mx-brief-result').hidden=false;
 });
 const pairing=root.querySelector('[data-pairing]');if(pairing)pairing.addEventListener('change',()=>{
 const data=root.querySelector('[data-wine-values]').dataset;root.querySelector('[data-wine-title]').textContent=data[pairing.value+'Title'];root.querySelector('[data-wine-copy]').textContent=data[pairing.value+'Copy'];
 });
});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mentor-header"] && !Shopify.designMode) return;
  try {
    
(()=>{document.addEventListener('click',event=>{document.querySelectorAll('.mw-mobile-menu[open]').forEach(menu=>{if(!menu.contains(event.target)||event.target.closest('nav a'))menu.open=false;});});document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.mw-mobile-menu[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});});})();

  } catch(e) { console.error(e); }
})();
})();
